var map = {
	"./symbol_0.png": "b419",
	"./symbol_1.png": "1328",
	"./symbol_10.png": "9cc2",
	"./symbol_11.png": "3400",
	"./symbol_12.png": "5ba73",
	"./symbol_13.png": "817e",
	"./symbol_14.png": "0ad2",
	"./symbol_15.png": "4a0f",
	"./symbol_16.png": "2c91",
	"./symbol_17.png": "49ee",
	"./symbol_2.png": "eaf9",
	"./symbol_3.png": "785b",
	"./symbol_4.png": "c7b2",
	"./symbol_5.png": "926b",
	"./symbol_6.png": "d470",
	"./symbol_7.png": "7229",
	"./symbol_8.png": "cd86",
	"./symbol_9.png": "6903"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79c2";